var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tooltip",
    {
      attrs: { disabled: !_vm.overLimit, bottom: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c(
                "v-text-field",
                _vm._g(
                  {
                    attrs: {
                      "error-messages": _vm.errorMessages,
                      hint: _vm.overLimit
                        ? _vm.$t("components.amountInput.overLimit")
                        : null,
                      label: _vm.contextLabel,
                      rules: _vm.computedRules,
                      suffix: _vm.suffix,
                      "prepend-icon": _vm.prependIcon,
                      placeholder: _vm.placeholder,
                      readonly: _vm.readonly,
                      "persistent-hint": _vm.overLimit,
                      loading: _vm.overLimit
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "progress",
                          fn: function() {
                            return [
                              _vm.overLimit
                                ? _c("v-progress-linear", {
                                    attrs: {
                                      color: "error",
                                      height: "7",
                                      value: "100",
                                      absolute: ""
                                    }
                                  })
                                : _vm._e()
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    ),
                    model: {
                      value: _vm.computedModel,
                      callback: function($$v) {
                        _vm.computedModel = $$v
                      },
                      expression: "computedModel"
                    }
                  },
                  on
                )
              )
            ]
          }
        }
      ])
    },
    [_vm._v(" " + _vm._s(_vm.$t("components.amountInput.overLimit")) + " ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }